var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBuy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.2488 1.50401C10.1397 1.5039 10.0316 1.52531 9.93071 1.56702C9.82986 1.60874 9.73822 1.66994 9.66105 1.74711C9.58388 1.82428 9.52268 1.91592 9.48097 2.01677C9.43925 2.11763 9.41784 2.22572 9.41795 2.33486L9.41206 15.163L6.11812 11.869C5.79403 11.5449 5.2637 11.5449 4.93961 11.869C4.61552 12.1931 4.61552 12.7234 4.93961 13.0475L9.65365 17.7616C9.97774 18.0857 10.5081 18.0857 10.8322 17.7616L15.5462 13.0475C15.8703 12.7234 15.8703 12.1931 15.5462 11.869C15.2221 11.5449 14.6918 11.5449 14.3677 11.869L11.0738 15.163L11.0738 2.32897C11.0738 1.88113 10.6966 1.50401 10.2488 1.50401Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBuy);
export default __webpack_public_path__ + "static/media/buy.f3ceed8360f6d985ad8cbb035cf521ec.svg";
export { ForwardRef as ReactComponent };